<template>
  <div class="container">
    <v-data-table
      v-if="listaSalasEspera.length"
      :headers="headers"
      :items="this.listaSalasEspera"
      class="elevation-1"
      locale="es-ar"
      item-key="idSalaEspera"
      :items-per-page="10"
      ref="myTable"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageText: 'Filas por página',
      }"
    >
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              medium
              color="purple"
              class="mr-3"
              v-on="on"
              v-bind="attrs"
              @click.stop="editarSalaEspera(item)"
              >mdi-pencil</v-icon
            >
          </template>
          <span>Editar Sala de Espera</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              medium
              v-on="on"
              color="red"
              v-bind="attrs"
              @click="borrarSalaEspera(item)"
              >mdi-delete</v-icon
            >
          </template>
          <span>Eliminar Sala de Espera</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-alert class="mt-4" color="purple" dark outlined v-else>
      No hay Salas de Espera configuradas para la institución.
    </v-alert>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click.stop="nuevaSalaEspera"
        >Nueva Sala de Espera</v-btn
      >
    </v-card-actions>
    <NuevaSalaEspera
      :visible="showNuevaSalaEspera"
      @close="cierraNuevaSalaEspera()"
      @salaEsperaRegistrada="salaEsperaRegistrada()"
    ></NuevaSalaEspera>
    <EditarSalaEspera
      :visible="showEditarSalaEspera"
      :idSalaEspera="editedItem.idSalaEspera"
      @close="cierraEditarSalaEspera()"
      @salaEsperaModificada="salaEsperaModificada()"
    ></EditarSalaEspera>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>
import axios from "../../axios-auth.js";
import router from "../../router/index.js";
import NuevaSalaEspera from "./NuevaSalaEspera.vue";
import EditarSalaEspera from "./EditarSalaEspera.vue";
export default {
  data: (vm) => ({
    listaSalasEspera: [],
    headers: [
      { text: "Nombre", value: "nombreSalaEspera" },
      { text: "Acciones", value: "actions" },
    ],
    showNuevaSalaEspera: false,
    showEditarSalaEspera: false,
    editedItem: {},
    editedIndex: -1,
  }),
  methods: {
    salir() {
      router.push({ path: "/Home" });
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 1500,
      });
    },

    borrarSalaEspera(item) {
      this.$swal({
        title: "Borrar Sala de Espera",
        text: "¿Desea borrar la sala de espera?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const idSalaEspera = item.idSalaEspera;
          let self = this;
          axios
            .get("/Profesional/BorrarSalaEspera?", {
              params: {
                idSalaEspera: idSalaEspera,
              },
            })
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "error",
                  title:
                    "Algun consultorio tiene asociado esta sala de espera. No se puede borrar.",
                  vm: self,
                });
              } else {
                self.showAlert({
                  icon: "success",
                  title: "Sala de Espera borrada exitosamente",
                  vm: self,
                });
                setTimeout(self.buscarSalasEspera(), 1700);
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "La Sala de Espera no pudo ser borrada",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    cierraNuevaSalaEspera() {
      this.showNuevaSalaEspera = false;
      //this.buscarObrasSociales();
    },
    cierraEditarSalaEspera() {
      this.showEditarSalaEspera = false;
      //this.buscarObrasSociales();
    },
    salaEsperaRegistrada() {
      this.showNuevaSalaEspera = false;
      this.buscarSalasEspera();
    },
    salaEsperaModificada() {
      this.showEditarSalaEspera = false;
      this.buscarSalasEspera();
    },
    nuevaSalaEspera() {
      this.showNuevaSalaEspera = true;
    },
    editarSalaEspera(item) {
      this.editedIndex = this.listaSalasEspera.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showEditarSalaEspera = true;
    },
    buscarSalasEspera() {
      const filtrosData = {
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Profesional/GetSalasEspera?", {
          params: {
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function(response) {
          if (response.data != null && response.data != "")
            self.listaSalasEspera = response.data;
          else self.listaSalasEspera = [];
        })
        .catch(function(error) {});
    },
  },
  created() {
    this.buscarSalasEspera();
  },
  components: {
    NuevaSalaEspera,
    EditarSalaEspera,
  },
};
</script>
